import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useFormik } from 'formik';
import React from 'react'

export default function CreateDialog({openCreateBrand, setOpenCreateBrand, handleCreate, message, model}) {
    const user = JSON.parse(localStorage.getItem('user'))
      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
      } = useFormik({
        initialValues: {
          brandName: "",
        },
      });

    return (
        <form>
            <Dialog aria-labelledby='dialog-title' onClose={() => setOpenCreateBrand(false)} open={openCreateBrand}>
                <DialogTitle id='dialog-title'>
                    Create Brand
                </DialogTitle>
                <DialogContent>
                <TextField
                    id="brandName"
                    type="text"
                    margin="dense"
                    value={values.brandName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Brand"
                />
                {errors.brandName && touched.brandName && (
                    <p className="error">{errors.brandName}</p>
                )}
                </DialogContent>
                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => {
                            setOpenCreateBrand(false)
                            values.brandName = ""
                        }}
                        variant="contained"
                    >Cancel</Button>
                                        <Button
                        color="primary"
                        onClick={() => {
                            //create new brand
                            handleCreate(values.brandName)
                            //reset brand name value
                            values.brandName = ""
                        }}
                        variant="contained"
                        >Yes</Button>
                </DialogActions>
            </Dialog>
        </form>
    )
}